import { NATIVE_SOL } from "@stepfinance/common";
import React, { useContext, useEffect, useState } from "react";

import { useOpenbookOrdersQuery } from "../hooks/queries/dex/useOpenbookOrdersQuery";
import { useMarkets } from "./market";

type DexContextState = {
  totalClosableAccountsRent: number;
  setDexBalance: (balance: number) => void;
  dexBalance: number;
  refreshContext: () => void;
};
const DexContext = React.createContext<DexContextState | null>(null);

export function DexContextProvider(props: any) {
  const [dexBalance, setDexBalance] = useState(0);
  const [totalClosableAccountsRent, setTotalClosableAccountsRent] = useState(0);
  const { priceInUSD } = useMarkets();

  const {
    data: openBookData,
    isFetching: isOpenBookDataFetching,
    status: openBookDataStatus,
    refetch,
  } = useOpenbookOrdersQuery();

  useEffect(() => {
    if (openBookDataStatus === "success" && !isOpenBookDataFetching) {
      const solPrice = priceInUSD(NATIVE_SOL.toBase58()) ?? 0;

      setDexBalance((openBookData.totalOrdersValueUSD ?? 0) + (openBookData.totalUnsettledValueUSD ?? 0));
      setTotalClosableAccountsRent(openBookData.totalClosableRentSOL * solPrice);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openBookDataStatus, isOpenBookDataFetching, priceInUSD]);

  return (
    <DexContext.Provider
      value={{
        totalClosableAccountsRent,
        refreshContext: refetch,
        setDexBalance,
        dexBalance,
      }}
    >
      {props.children}
    </DexContext.Provider>
  );
}

export function useDexContext(): DexContextState {
  const ctx = useContext(DexContext);
  if (ctx === null) {
    throw new Error("Context not available");
  }
  return ctx;
}
